import type { FundingConfigurations } from 'api';

// get account numbers that are configured for crypto
// by checking if the account's funding instructions
// have crypto network and wallet address configured
export function getCryptoAccountNumbers(
  fundingInstructions: FundingConfigurations
): Set<string> {
  return new Set(
    Object.values(fundingInstructions ?? {})
      .flat()
      .filter(
        (item) =>
          item.beneficiary?.crypto_network && item.beneficiary?.wallet_address
      )
      .map((item) => item.virtual_account_number)
  );
}
